import React from 'react';
import { Select } from '@radix-ui/themes';

const perSize = [
   { label: '10', value: '10' },
   { label: '25', value: '25' },
   { value: '50', label: '50' },
];

export const PageSize = ({
   size,
   onChangeSize,
}: {
   size: number;
   onChangeSize: (value: number) => void;
}) => {
   return (
      <div className="ml-5 w-[110px]">
         <Select.Root
            onValueChange={(value: string) => {
               onChangeSize(Number(value));
            }}
            value={size.toString()}
            name="pag-page-size"
            // options={perSize}
         />
      </div>
   );
};
